import type { FetchBaseQueryError } from "@reduxjs/toolkit/query";

export const getFetchQueryErrorStatus = (
    error: unknown,
): number | undefined => {
    if (typeof error !== "object" || error === null || !("status" in error)) {
        return undefined;
    }

    const { status } = error as FetchBaseQueryError;

    if (typeof status === "number") {
        return status;
    }

    return undefined;
};
